import React from "react"
import styled from "styled-components"

import { Link } from "gatsby"

import { TextGroup, Media, Card2 } from "components/common"

import { device } from "utils"
import { motion } from "framer-motion"
import { PostAuthors } from "."

const PostCard = ({ post, authors, type, time }) => {
  const { slug, excerpt, date, title, cover } = post
  // const { cursor } = useStaticQuery(QUERY)

  // const { handleMouseMove, pos, ref, isHovered } = useMousePosition()

  return (
    <Link
      to={`/${type}/${slug}`}
      // onMouseMove={handleMouseMove}
      // ref={ref}
      style={{ position: "relative", zIndex: 30 }}
    >
      <Card2 style={{ padding: 0 }}>
        <StyledPostCard className="postCard">
          <div className="textContainer">
            <div className="hatWrap">
              <h4 className="hat">{date}</h4>

              {time && (
                <>
                  <span className="pipe">|</span>
                  <h4 className="time">{time.text}</h4>
                </>
              )}
            </div>

            <TextGroup
              className="description"
              title={title}
              titleAs="h3"
              subtitle={excerpt?.childMarkdownRemark.rawMarkdownBody}
              subtitleAs="p"
            />
            {authors && <PostAuthors authors={authors} />}
          </div>

          <div className="cardImageWrap">
            <Media className="postCardImage" media={{ desktop: cover }} />
          </div>

          {/* <AnimatedCusor
          className="animatedCursor"
          style={{ top: pos.y, left: pos.x, x: "-50%", y: "-50%" }}
          animate={{
            opacity: isHovered ? 1 : 0,
            scale: isHovered ? 1 : 0,
          }}
        >
          </AnimatedCusor> */}
          <motion.div
            className="inner"
            animate={{
              rotate: 360,
            }}
            transition={{
              repeat: Infinity,
              duration: 10,
              ease: "linear",
            }}
          >
            {/* <Media media={cursor} /> */}
          </motion.div>
        </StyledPostCard>
      </Card2>
    </Link>
  )
}

// const AnimatedCusor = styled(motion.div)`
//   display: none;
//   opacity: 0;
//   @media ${device.laptop} {
//     position: absolute;
//     display: inline-block;
//     pointer-events: none;
//     will-change: top, left;
//     /* border: 1px solid red; */
//   }
// `

const StyledPostCard = styled.li`
  --tg-hat-color: var(--font);
  --tg-grid-gap: var(--sp-8);
  transition: 0.1s transform ease-in-out;
  position: relative;
  display: grid;
  grid-gap: var(--sp-24);

  @media ${device.laptop} {
    overflow: hidden;
    grid-template-columns: max(60%, 435px) auto;

    &:hover {
      .postCardImage {
        transform: scale(1.02);
      }
    }
  }

  .hatWrap {
    display: grid;
    grid-template-columns: auto auto auto;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: var(--sp-16);
    grid-gap: var(--sp-4);

    .hat {
      font-size: 1.125rem;
      line-height: 1;
      color: var(--body);
      font-weight: 500;
    }
    .pipe {
      font-weight: 400;
      color: var(--body);
    }
    .time {
      font-weight: 500;
      font-size: 1.125rem;
      line-height: 1;
      color: var(--body);
    }
  }

  .textContainer {
    display: flex;
    flex-direction: column;
    padding: var(--sp-24);
    padding-bottom: 0;

    @media ${device.laptop} {
      padding: var(--sp-56);

      padding-right: 0;
    }
    .description {
      .hat {
        font-size: 0.875rem;
      }

      .title {
        font-size: 2rem;
        line-height: 32px;
      }
    }
  }

  .cardImageWrap {
    padding: var(--sp-24);
    padding-top: 0;

    @media ${device.laptop} {
      padding: var(--sp-56);
      padding-left: 0;
    }
    .postCardImage {
      width: 100%;
      height: 100%;
      transition: 0.2s transform ease-in-out;

      .gatsby-image-wrapper {
        height: 100%;
        width: 100%;
      }
    }
  }

  .authors {
    padding-top: var(--sp-16);
    margin-top: auto;
  }
`

// const QUERY = graphql`
//   {
//     cursor: contentfulMedia(mediaId: { eq: "blogCursor" }) {
//       ...Media
//     }
//   }
// `

export default PostCard
